import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { NoteService } from 'src/app/services/notes/note.service';

@Component({
  selector: 'app-note-feeds-list',
  templateUrl: './note-feeds-list.component.html',
  styleUrls: ['./note-feeds-list.component.css']
})
export class NoteFeedsListComponent {

  userID;
  @Input() note; // decorate the property with @Input()
  @Output() newItemEvent = new EventEmitter<string>();

  constructor(
    private noteSrv: NoteService,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe(info => {
      this.userID = info.user.id;
    });
  }

  viewSingleNote(value: any) {
    this.noteSrv.noteItem.next(value);
  }

}
